export enum TestId {
	// CAUTION: if you update this you'll need to update the contents of the scripts in src/ssr-scripts.
	BYLINE = 'analytics-byline',
}

// CAUTION: if you update this you'll need to update the contents of the scripts in src/ssr-scripts.
export const SSR_EVENTS_CAPTURE_KEY = 'analyticsByLine';

export const CLICKED_BYLINE_SSR_MARK = 'clicked-analytics-byline-fmp-ssr.rendered';
